import React from 'react';
import Translate from 'react-translate-component';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

const ApprovalStatus = ({ status, senderName, typeName }) => (status || senderName || typeName) ? (
    <div>
        <DefinitionHeader iconType='check-circle'>
            <Translate content='status' component='span'/>:
            <span> { status }</span>
        </DefinitionHeader>
        <div className='panel-view'>
            <span>{ typeName }</span><br/>
            <span>{ senderName }</span>
        </div>
    </div>
) : null;

export default ApprovalStatus;
